import React from 'react';

interface BoltIconProps {
  /**
   * Icon color, defaults to currentColor
   */
  fill?: string;
  /**
   * Icon width
   */
  width?: number;
  /**
   * Icon height
   */
  height?: number;
  /**
   * CSS className
   */
  className?: string;
}

const BoltIcon: React.FC<BoltIconProps> = ({
  fill = 'currentColor',
  width = 14,
  height = 20,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M3.80371 19.6L4.97409 11.9643H0L8.75439 0H9.2951L8.14814 8.63717H14L4.34442 19.6H3.80371Z"
        fill={fill}
      />
    </svg>
  );
};

export default BoltIcon;
